import weatherDashboardSlice from './weatherDashboardSlice';

const weatherSlices = [weatherDashboardSlice];

export default weatherSlices;
